<form [formGroup]="testLinkForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Активирование ссылки</h3>
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field>
        <mat-label>Название</mat-label>
        <input matInput formControlName="name" placeholder="Введите название"
               autocomplete="off" [autofocus]="['autofocus']">
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>Почта кандидата</mat-label>
        <input matInput formControlName="mail" 
             placeholder="Введите почту кандидата"
             type="email"
             autocomplete="off" >
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>Действует с</mat-label>
        <input matInput formControlName="startDate" [matDatepicker]="startDatePicker"
               autocomplete="off"
               [max]="testLinkForm.controls.finishDate.value">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Действует по</mat-label>
        <input matInput formControlName="finishDate" [matDatepicker]="finishDatePicker"
               autocomplete="off"
               [min]="testLinkForm.controls.startDate.value">
        <mat-datepicker-toggle matSuffix [for]="finishDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #finishDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-checkbox [checked]="isFinishless"
                    (change)="onFinishlessChange($event)">Бессрочная
      </mat-checkbox>
    </div>
    <div class="row">
      <mat-checkbox [checked]="testLinkForm.controls.isMixedQuestions.value"
                    formControlName="isMixedQuestions"
                    (change)="onMixedQuestionsChange($event)">Перемешать вопросы
      </mat-checkbox>
      <mat-checkbox [checked]="testLinkForm.controls.isMixedOptions.value"
                    formControlName="isMixedOptions"
                    (change)="onMixedOptionsChange($event)">Перемешать ответы
      </mat-checkbox>
    </div>
    <div class="row">
      <mat-checkbox [checked]="testLinkForm.controls.allQuestionsRequired.value"
                    formControlName="allQuestionsRequired"
                    (change)="onAllQuestionsRequiredChange($event)">Требовать ответы на все вопросы
      </mat-checkbox>
    </div>
    <div class="row">
      <mat-checkbox [checked]="testLinkForm.controls.trackTelegramUsers.value"
                    formControlName="trackTelegramUsers"
                    (change)="onTrackTelegramUsersChange($event)">Отслеживать пользователей Telegram
      </mat-checkbox>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            cdkFocusInitial
            (click)="onSubmit($event)">Активировать
    </button>
  </div>
</form>
